<template>
  <div id="bmap-container"></div>
</template>

<script>
import { isSupportCanvas } from '@/utils/utils';
import { loadBMap } from '@/utils/map';

export default {
  data() {
    return {
      map: null
    };
  },
  methods: {
    loaded() {
      this.$emit('loaded', this.map);
    },
    initMap(options) {
      options = Object.assign(
        {
          tilt: 60,
          heading: 0
        },
        options
      );
      const map = new BMapGL.Map('bmap-container', {
        restrictCenter: false
      });
      this.map = map;
      const point = new BMapGL.Point(116.403748, 39.915055);
      map.enableKeyboard();
      map.centerAndZoom(point, 17);
      map.enableScrollWheelZoom();
      map.enableInertialDragging();
      map.enableContinuousZoom();

      // map.setDisplayOptions(
      //   options.displayOptions || {
      //     indoor: false,
      //     poi: true,
      //     skyColors: options.skyColors || ['rgba(5, 5, 30, 0.01)', 'rgba(5, 5, 30, 1.0)']
      //   }
      // );
      if (options.center && options.zoom) {
        let center = options.center;
        if (center instanceof Array) {
          center = new BMapGL.Point(options.center[0], options.center[1]);
        }
        map.centerAndZoom(center, options.zoom, options);
      }
      // 倾斜
      // map.setTilt(options.tilt);
      map.setHeading(options.heading);
      // 回调
      this.loaded();
    }
  },
  async mounted() {
    if (!isSupportCanvas) {
      this.$message({ type: 'warning', message: '浏览器不支持canvas无法展示模型，请更换浏览器' });
    } else {
      await loadBMap('1.0', 'webgl', 'BMapGL');
      this.$nextTick(() => {
        this.initMap();
      });
    }
  },
  beforeDestroy() {
    this.map.destroy();
  }
};
</script>

<style lang="scss">
#bmap-container {
  width: 100%;
  height: 100%;
  margin: 0;
}
</style>
